<template>
	<app tabbar :create-button="!!createPath" @create="navigateTo(createPath)">
		<scroll-list ref="list">
			<template v-slot="{data}">
				<scroll-item>
					<div class="flex-between-center">
						<div class="code">申请时间：{{data.create_date}}</div>
						<div class="info"><span :style="{'color': proceedState[data.state].color}">{{proceedState[data.state].name}}</span></div>
					</div>
					<div class="name">{{data.project_name}}</div>
					<div class="info">监理单位：{{data.jldw_name}}</div>
					<button-group slot="button">
						<c-button v-if="data.state == 1 && power('8')" @click="navigateTo('/proceed_detail', {id: data.id})">审批</c-button>
						<c-button v-else color="gray" hollow @click="navigateTo('/proceed_detail', {id: data.id})">查看详情</c-button>
						<c-button v-if="data.state == 4 && power('7')" @click="navigateTo('/proceed_apply', {id: data.id})">重新编辑</c-button>
					</button-group>
				</scroll-item>
			</template>
		</scroll-list>
	</app>
</template>

<script>
	import {mapGetters} from 'vuex'
	
	export default {
		computed: {
			...mapGetters(['power', 'proceedState']),
			
			createPath() {
				if (this.power('7')) {
					return '/proceed_apply';
				}
			}
		},
		
		mounted() {
			this.updateList();
		},
		
		methods: {
			updateList() {
				this.$refs.list.load({
					url: '/project/kgl/list'
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
